import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

export default class CourseReport extends Component {
  state = {
    data: [
      {
        id: "1",
        name: "Course 1",
        categoryName: "Sample Catagory Name",
        compeletedLearner: [
          {
            id: 1,
          },
          {
            id: 2,
          },
        ],
        assignedLearner: [
          {
            id: 1,
          },
          {
            id: 2,
          },
          {
            id: 3,
          },
        ],
      },
      {
        id: "2",
        name: "Course 2",
        categoryName: "Sample Catagory Name",
        compeletedLearner: [
          {
            id: 1,
          },
          {
            id: 2,
          },
          {
            id: 3,
          },
        ],
        assignedLearner: [
          {
            id: 1,
          },
          {
            id: 2,
          },
        ],
      },
    ],
    columns: [
      {
        name: "Course",
        selector: "name",
        sortable: true,
      },
      {
        name: "Catagory",
        selector: "categoryName",
        sortable: true,
        center: true,
      },
      {
        name: "Assigned learner",
        selector: "assignedLearner",
        sortable: true,
        center: true,
        cell: (row) => (
          <div className="d-flex">{row.assignedLearner.length}</div>
        ),
      },
      {
        name: "Completed learner",
        selector: "compeletedLearner",
        sortable: true,
        center: true,
        cell: (row) => (
          <div className="d-flex">{row.compeletedLearner.length}</div>
        ),
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: (row) => (
          <div className="d-flex">
            <Link to={`/admin/reports/course/${row.id}`}>
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };

  componentDidMount() {
    // API will be called from here
  }

  render() {
    return (
      <div>
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /
                  <Link to="/admin/reports">Report</Link> /
                  <Link to="/admin/reports/course">Course Report</Link>
                </h5>
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
              pagination={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
